import React from 'react';
import styles from '../CallConnectionScreen.module.scss';
import { useLanguage } from '@/localization/useLanguage';
import { useIncomingCall } from '@/features/calls/viewmodels/useOutgoingCall';

import { IconDeclineCallIcon, IconIncomingCallIcon } from '@/assets/images';

/**
 * Pure rendering component — no SDK imports.
 * endCall comes from useOutgoingCall() viewmodel.
 */
export const IncomingCallScreen = () => {
   const { t } = useLanguage();
   const { handleAttend, handleDecline } = useIncomingCall();

   return (
      <>
         <button
            className={`ct-flex ct-aiCenter ct-jcCenter ${styles.incomingActionButton} ${styles.accept}`}
            onClick={handleAttend}
            title={t('common.ANSWER')}
            aria-label={t('common.ANSWER')}
         >
            <i className="ct-icon">
               <IconIncomingCallIcon />{' '}
            </i>
         </button>
         <button
            className={`ct-flex ct-aiCenter ct-jcCenter ${styles.incomingActionButton} ${styles.decline}`}
            onClick={handleDecline}
            title={t('common.DECLINE')}
            aria-label={t('common.DECLINE')}
         >
            <i className="ct-icon">
               <IconDeclineCallIcon />{' '}
            </i>
         </button>
      </>
   );
};
